import ajaxService from './ajaxService';

export default {
  // 取得會員紅利資料
  getMemberBonus(body, headers) {
    return ajaxService.post('/pmt/post/api/v1/member-bonus-query', body, headers);
  },
  // 轉贈會員紅利
  postMemberBonusTransfer(body, headers) {
    return ajaxService.post('/pmt/post/api/v1/member-bonus-transfer', body, headers);
  },
  // coupon優惠券轉贈
  postCustomizeCouponTransfer(body, headers) {
    return ajaxService.post('/pmt/post/api/v1/customize-coupon/transfer', body, headers);
  },
  putCustomizeCouponUsage(body) {
    return ajaxService.post('/pmt/put/api/v1/customize-coupon/usage', body);
  },
  // 取得電子票夾列表
  getEticketList(param) {
    const queryString = new URLSearchParams(param).toString();
    return ajaxService.post(`/pmt/get/api/v1/eticket-list?${queryString}`);
  },
  // 取得電子票夾列表數量
  getEticketListCount(param) {
    const queryString = new URLSearchParams(param).toString();
    return ajaxService.post(`/pmt/get/api/v1/eticket-list-cnt?${queryString}`);
  },
};
